import React from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { withRouter } from "react-router-dom"
import withBaseComponent from '../../withBaseComponent'
import { connect } from 'react-redux'
import i18n from '../../../i18n';
import {mapDispatchToProps} from "../../mapDispatchToProps"
import { trackingEvent } from "./GoogleAnalytics.js"
import { screens } from '../screen'
import { loginApiUrl, clientId, redirectUri} from '../../../actions/config'

class Header extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props)

    this.toggleProfile = this.toggleProfile.bind(this)
    this.trackingSupport = this.trackingSupport.bind(this)
    this.trackingLogout = this.trackingLogout.bind(this)

    this.state = {
      open: false
    }
  }

  activeScreen(path) {
    let pathname = path.slice(1)
    this.props.screenActions.setScreenInfo(screens[pathname.replace(/-/g, '_')])
  }

  onLogout() {
    localStorage.removeItem('mf_authorization');
    localStorage.removeItem('oauth_authorize');
    localStorage.removeItem("refererUrl")
    this.props.sessionActions.defaultSession({isFetchingSession: false})
    window.location.href = `${loginApiUrl}end_session?client_id=${clientId}&post_logout_redirect_uri=${redirectUri}`
  }

  toggleProfile() {
    this.setState({
      toggle: !this.state.toggle
    });
  }

  userSetting() {
    trackingEvent("User", "ユーザー設定")
    this.props.history.push('/user-setting')
    this.activeScreen('/user-setting')
  }

  trackingLogout() {
    trackingEvent("User", "ログアウト")
    this.onLogout()
  }

  trackingSupport() {
    trackingEvent("Support", "メニュー")
    this.props.history.push('/support')
    this.activeScreen('/support')
  }

  render() {
    const activeClass = this.props.location.pathname === '/support' ? 'active' : ''

    return (
      <header>
        <nav className="navbar navbar-expand-md navbar-light fixed-top">
          <a className="navbar-brand" href="/">
            <img src={require('../../../../assets/images/logo.png')} className="img-fluid" alt="logo.png" />
          </a>
          <h1 className="w-25 text-left title">{this.props.titleScreen}</h1>
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <button className="btn-link nav-link" rel="nofollow" onClick={this.trackingSupport}>
                <i className={`fas fa-question-circle align-middle ${activeClass}`}></i>
                {i18n.t('header.support')}
              </button>
            </li>
            { this.props.userEmail && <li className="nav-item">
              <ButtonDropdown onClick={ () => trackingEvent("User", "メニュー") } direction="down" isOpen={this.state.toggle} toggle={this.toggleProfile} className="profile">
                <DropdownToggle className={`btn-link nav-link ${this.state.toggle ? 'active' : ''}`}>
                  <i className={`fas fa-user align-middle ${this.state.toggle || ['/user-setting'].includes(this.props.location.pathname) ? 'active' : ''}`}></i>
                  <span>{this.props.userEmail.split("@")[0]}</span>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => this.userSetting()}>{i18n.t('header.user_setting')}</DropdownItem>
                  <hr/>
                  <DropdownItem onClick={this.trackingLogout}>
                    <i className="fas fa-sign-out-alt align-middle"></i>
                    <span>{i18n.t('header.logout')}</span>
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            </li>
            }
          </ul>
        </nav>
      </header>
    )
  }
}

function mapStateToProps(state) {
  const screen = state.screen

  return {
    titleScreen: screen.get("title"),
    userEmail: state.user.get('email')
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header))
